import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AssignmentType } from '../../../../model';
import { Accordion, ActionPanel, GenericViewer, SvgImage, IconButton, Tab } from '../../../../components';
import { BomItem, Diagram, ModelDebugViewer, UiGroup } from '.';
import { getLanguages, translate } from '../../../../services';
import { productState, siteSettingsState, combineStates, exportDispatcher, currentNodeState, identityState, combineDispatchers, productsDispatcher, priceDispatcher, popupDispatcher, feasibilityDispatcher, screenSizeState, currentPageState, currentPageDispatcher, screenSizeDispatcher,modelConfiguratorDispatcher,modelConfiguratorState } from '../../../../store';
import { assignmentDecision, getAssignedValue, hasAnyAssignableValues, isRequired, deflateModelVariables, getValues, convertToLineItem, getProductDescription, updateProductDescription,checkIsBomItemMain } from '../../../../util';
import { warningIcon1, downloadIcon, GreyFilterEmptyIconNew,addIcon } from '../../../../../style/images';
import { PropTypes } from 'prop-types';
import { FeasibilityPopup } from './FeasibilityPopup';
import { BreadcrumbHeader } from '../../navigation';
import SelectFilterMessage from '../accessories/SelectFilterMessage';
import { isEqual, uniq } from 'lodash';
import { WildArticle } from '../../../components/WildArticle';

const isValidBomElement = products => bom => {
  const value = getAssignedValue( bom );
  return !value ? false : products[value];
};

const isProductAvailable = products => variant => {
  if(!products[variant]){
    return false
  }
  return true;
}

export class ModelConfiguratorComponent extends Component {
  state = { currentPage : 1, productsCount: 0,  wildArticles:[], lastIP: undefined, showTapOffUnitWarning: false, totalPages: 0, requiredAssignments : null, multiValueProducts : [], mainProduct : undefined, checkForInputFields:false}


  setCheckForInputFields = (flag)=>{
    this.setState({checkForInputFields:flag})
  }
  componentDidMount(){
    this.assignCountry();
    const { configuration, currentNode } = this.props;
    const { model } = configuration;
    const lang = getLanguages().first();
    const { variantSource, isVT } = currentNode && currentNode.customProperties;
    const unsetRequiredVariables = this.getAllVariables( model ).filter( variable => isRequired( variable ) && !getAssignedValue( variable ) );

    const loadProducts = this.canLoadProducts(unsetRequiredVariables);
    
    if(this.props.screenSize.height===0 || this.props.screenSize.width===0){
      this.props.resizeScreen()
    }
    
    if(variantSource && loadProducts){
    const variantsFromModel = this.getVariants( model, variantSource, lang );
    this.props.getProducts( variantsFromModel.map( v=> v.name )).then( () => this.setState( {totalPages : Math.ceil( variantsFromModel.length / 20)}));
    }
  }
  productloadIntiated = {};
  componentDidUpdate(){
    const { configuration, currentNode,siteSettings } = this.props;
    const { model } = configuration;
    const lang = getLanguages().first();
    const { variantSource, productBlockers } = currentNode && currentNode.customProperties;
    const unsetRequiredVariables = this.getAllVariables( model ).filter( variable => isRequired( variable ) && !getAssignedValue( variable ) && variable.show);
    const allVariables = this.getAllVariableValues( model );

    let {noTapOffUnitIPs, noTapOffUnitField} = siteSettings.properties;
    let currentIP = configuration.model.children[0].variables.find(v => v.fullyQualifiedName === noTapOffUnitField)?.assignedValue?.name;
    if(this.state.lastIP !== currentIP) {
      this.setState({lastIP: currentIP});
      const noTapOffUnit = noTapOffUnitIPs.includes(currentIP);
      if(!this.state.showTapOffUnitWarning && noTapOffUnit) this.setState({showTapOffUnitWarning: true});
    } else if(this.state.showTapOffUnitWarning) this.setState({showTapOffUnitWarning: false})

    const loadProducts = this.canLoadProducts(unsetRequiredVariables);
    //to load products when user selects the productBlockers variable
    if(variantSource && loadProducts && productBlockers){
    const variantsFromModel = this.getVariants( model, variantSource, lang );
  
    if(configuration.products && configuration.products.length > 0){
      if((JSON.stringify( this.state.requiredAssignments) !== JSON.stringify(configuration.products))){
        this.setState({requiredAssignments: configuration.products}, ()=>{this.props.getProducts(configuration.products);});
      }
    }
    else{
      if((JSON.stringify( this.state.requiredAssignments) !== JSON.stringify(variantsFromModel))){
        this.setState({requiredAssignments: variantsFromModel}, ()=>{this.props.getProducts(variantsFromModel.map( v=> v.name ));});
      }
    }
  }
  }

  componentWillReceiveProps(nextProps) {
    if(!isEqual(this.props.oldProduct, nextProps.oldProduct)|| (this.state?.wildArticles?.length==0&& nextProps.oldProduct && nextProps.oldProduct.wildArticles)){
      this.setState({wildArticles: nextProps.oldProduct?.wildArticles})
    }
  }

  assignCountry () {
    const { configuration, product, user } = this.props;
    if( configuration ){
      const variables = configuration.model.children.filter( val => val.title == 'Availability' )
      for ( let variable of variables ) {
        if( variable.variables[0].name == 'LSO'){
          this.props.assignValue( variable.variables[0].fullyQualifiedName, user.country );
        }
      }
    }
  }

  onScroll = ( e ) => {
    const { clientHeight, scrollTop, scrollHeight } = e.target;

    if ( scrollTop > ( scrollHeight - clientHeight ) * 0.75 && this.state.currentPage + 1 < this.state.totalPages ) {
    this.setState( { currentPage: ++this.state.currentPage } );
    }
  }

  getVariants = ( model, variantSource, lang ) =>{
    const variable = this.getAllVariables( model ).firstOrDefault( v => v.fullyQualifiedName === variantSource );
    const assignedValue = getAssignedValue( variable );
    if ( assignedValue ){
      return [ { name: assignedValue } ]
    }

    return getValues( variable, variable.values, lang );  
  }

  getAllVariables( model ) {
    return deflateModelVariables( model );
  }

  getAllVariableValues(model){
    const variables = this.getAllVariables(model);
    var allVariables = [];
    variables.map(v=>{allVariables.push(v.name+':'+v.textValue)});
    return allVariables;
  }

  getBomItems( model, { productModelType }, lang, variantSource, unsetRequiredVariables,currentNode ) {
    if( variantSource ){
      const { configuration } = this.props;
      const variable = this.getAllVariables( model ).firstOrDefault( v => v.fullyQualifiedName === variantSource );
      const variants = this.getVariants( model, variantSource, lang);
      this.productsCount = configuration.products && configuration.products.length > 0 ? configuration.products.length : variants && variants.length;
      //const canShowButton = this.validateInputFields(model);
      if(configuration.products && configuration.products.length > 0){
        return configuration.products.map(p => this.mapProductProperties(this.props.products[p], variable, unsetRequiredVariables, this.validateInputFields(model),currentNode)).slice(0,this.state.currentPage * 20);

      }else{
      return variants.map( v => this.mapProductProperties( this.props.products[v.name], variable, unsetRequiredVariables, this.validateInputFields(model),currentNode )).slice(0, this.state.currentPage * 20 );
      }
    }
    let isMainProductHasChanged = false;
    let mainProductCode = null;
    const {multiValueProducts, mainProduct} = this.state;
    const boms = this.getAllVariables( model ).filter( assignmentDecision( productModelType, lang ) ).map(b => {
      b.properties.IsBomItemMain = b.properties.IsBomItem && b.properties.BomItemType === "Main";
      let productCode = b.assignedValue?.name;
      let IsMultiple = b.properties.BomItemType === "MultiValue";
      if(IsMultiple && !multiValueProducts.find(t => t.assignedValue.name === productCode)) {
        multiValueProducts.push(b);
        this.setState({multiValueProducts: multiValueProducts});
      }
      if(b.properties.IsBomItemMain && productCode) {
        mainProductCode = productCode;
        if(mainProduct !== productCode) {
          if(mainProduct != undefined) isMainProductHasChanged = true;
          this.setState({ mainProduct : productCode })
        }
      }
      return b;
    });

    if(isMainProductHasChanged) {
        if(!window.location.href.includes('reconfigure')){
      this.props.resetQuantityList();
        }
      this.setState({multiValueProducts: [], wildArticles: []});
      let multiValueGroups = boms.filter(b => b.properties.BomItemType === "MultiValue")?.map(g => g.group);
      const uiGroupsList = model.children.filter( group => hasAnyAssignableValues( group ) && group.fullyQualifiedName != 'Availability' );
      multiValueGroups.forEach(group => this.props.resetGroup(null, uiGroupsList.find(g => g.title === group)))
      return boms.filter(b => b.properties.BomItemType !== "MultiValue");
    } else {
      if(this.props.oldProduct?.code === mainProductCode && this.props.oldProduct?.multiValueProducts) {
        for(let p of this.props.oldProduct?.multiValueProducts) {
          if(!multiValueProducts.find(t => t.assignedValue.name === p.assignedValue.name)) {
            multiValueProducts.push(p);
            this.setState({multiValueProducts: multiValueProducts});
          }
        }
      }
      return boms.concat(multiValueProducts.filter(t => this.props.modelConfigurator[t.assignedValue.name] > 0  && !boms.find(b => t.assignedValue.name === b.assignedValue.name)));
    }
  }

  validateInputFields(model){
    const variables = this.getAllVariables( model );
    const inputFields = variables.firstOrDefault(v=>v.showAs === 'InputField' && v.show);
    if(inputFields && inputFields.assignedValue && inputFields.assignedValue.name && inputFields.properties.Max && inputFields.properties.Min){
      if(isNaN(parseFloat(inputFields.assignedValue.name))){
        return false;
      }
      const formattedValue = inputFields.assignedValue.name.replace(',','.');
      return parseFloat(formattedValue) > parseFloat(inputFields.properties.Max) || parseFloat(formattedValue) < parseFloat(inputFields.properties.Min) ? false : true;
    }
    return true;
  }
  getProducts( boms, unsetRequiredVariables ) {
    const { products } = this.props;
    const { configuration, currentNode }= this.props;

    return boms.filter( bom => isValidBomElement( products )( bom ) ).map( bom => {
      const product = products[getAssignedValue( bom )];
      return this.mapProductProperties( product, bom, unsetRequiredVariables, true,currentNode );
    } );
  }

  mapProductProperties ( product, bom, unsetRequiredVariables, canShowButton  ){
    const { configuration, currentNode,siteSettings }= this.props;
    const amount = bom.properties.Quantity || 1;
    const isBomItemMain = bom.properties.IsBomItem && bom.properties.BomItemType === "Main";
    const fixedAmount = !!bom.properties.Quantity;
    const description = product && updateProductDescription( product.description,  configuration, currentNode,siteSettings);
    const hideAddButton = unsetRequiredVariables.length > 0 || canShowButton === false;
    if(isBomItemMain) {
      const configuration = isBomItemMain ? this.props.configuration : undefined;
      const isConfigurable = isBomItemMain;
      return { ...product, amount, isBomItemMain, fixedAmount, description, multiValueProducts: this.state.multiValueProducts, hideAddButton, isConfigurable, configuration };
    }
    if(description && currentNode.customProperties.isVT){
    product.description = description;
    product.productDescription = description;
    }
    else if(description && (!currentNode.customProperties.isVT)){
      product.description = description;
    product.productDescription = description;
    }
    return { ...product, amount, fixedAmount, description, hideAddButton };
  }

  //Method for dynamically updating Power factor(Pf) in VT product's description.
  updateVTDescription(description,variable){
    var value = variable?.properties?.CalculatedValue;
    var descriptionArr = description.split("Pf");
    var pfCount = descriptionArr.length - 1;
    var windingNo = variable.properties.Name.charAt(10);

    //Pf with "??""
    if(descriptionArr[windingNo]?.includes("??")){ 
      var temp = descriptionArr[windingNo].replace('??',value);
      descriptionArr[windingNo] = temp;
    }
    //When Pf selected value is changed
    // Pf value followed by "/"
    else if (!descriptionArr[windingNo]?.includes("     ") && descriptionArr[windingNo].includes("/") && !descriptionArr[windingNo].includes(value)){ 
      var temp = descriptionArr[windingNo].replace(descriptionArr[windingNo].substring(0,descriptionArr[windingNo].length - 1),value);
      descriptionArr[windingNo] = temp;
      }
    //When Pf selected value is changed
    //Pf followed by "     "
    else if(descriptionArr[windingNo]?.includes("     ") &&  !descriptionArr[windingNo].substring(0,3).includes(value)){ 
        var descriptionArr2 = descriptionArr[windingNo].split("     ");
        if(!descriptionArr2[0].includes(value)){
          descriptionArr2[0] = value;
          var tempStr = descriptionArr2[0] + "     " + descriptionArr2[1];
          descriptionArr[windingNo] = tempStr;
        }
      }
    switch(pfCount-1){
      case 0:
        return description = descriptionArr[0] + "Pf" + descriptionArr[1];
      case 1:
        return description = descriptionArr[0] + "Pf" + descriptionArr[1] + "Pf" + descriptionArr[2];
      case 2:
        return description = descriptionArr[0] + "Pf" + descriptionArr[1] + "Pf" + descriptionArr[2] + "Pf" + descriptionArr[3];
    }
  }

  //updating the product description with the user selected values
  //Variansts for which the update description happen available in hierarchy.json as concatenators
  updateProductDescription ( description ){
    const { configuration, currentNode }= this.props;
    const { model } = configuration;
    const variables = this.getAllVariables( model );
    const { concatenators, serviceConfigurator, isVT } = currentNode && currentNode.customProperties;
    return concatenators && concatenators.reduce( ( description, current ) => { 
      const variable = variables.firstOrDefault( v => v.fullyQualifiedName === current );
      const assignedValue = variable && getAssignedValue( variable );
      //const assignedValue = variable && variable.properties && variable.properties.CalculatedValue ? variable.properties.CalculatedValue : `${variable.title};`+getAssignedValue( variable );
      if ( assignedValue){
        //For VT dynamic description is for Power factor field. Hence using a separate condition and method.
        if(isVT && assignedValue!= 'Not applicable'){
          description = updateVTDescription(description,variable);
        }
        else if (!isVT)
        description = `${description.toString().trim()} ${variable && variable.properties && variable.properties.CalculatedValue ? variable.properties.CalculatedValue : ""}`;
      }
      return description;
    }, description );
  }

  //to Load/Hide Generic viewer component for specual view (variantSource)
  //productBlockers to be specified in hierarchy.json for the currentNode
  //Block loading of product unti user selects item mentioned in productBlockers. This should be a mandatory field as well
  //Requrement to reduce the number of products to be laoded
  canLoadProducts(unsetRequiredVariables){
    const { currentNode }= this.props;
    const {productBlockers} = currentNode && currentNode.customProperties;
    if(productBlockers){
    return productBlockers.reduce((unsetRequiredVariables,current) => {
      const loadProdut = unsetRequiredVariables.firstOrDefault(u =>u.fullyQualifiedName === current);
      if(loadProdut){
        return false
      }

      return true;
    },unsetRequiredVariables);
  }
    return true;
  }

  getChartItem( model ) {
    return this.getAllVariables( model ).firstOrDefault( variable => 
      variable.properties && variable.properties.IsChartItem && variable.assignedValue && variable.assignedValue.name !== 'Not applicable' 
    );
  }

  handleReset = ( group, index ) => {
    const { resetConfigurator, resetGroup } = this.props;
    return e => {
      e.preventDefault();
      this.accordion && this.accordion.resetState();
      if ( index === 0 ) {
        resetConfigurator();
        this.setState({wildArticles: []})
        return;
      }
      resetGroup( e, group );
      this.setState( { currentPage : 1})
    };
  }

  getRequiredTooltip( unsetRequiredVariables ) {
    const { currentNode } = this.props;
    const { variantSource } = currentNode && currentNode.customProperties;
    if(variantSource){
      return `${translate( 'Please select' )}: ${unsetRequiredVariables.map( variable => `${variable.title}'` ).join( ' | ' )}`;
    }
    return `${translate( 'Unselected required variables' )}: ${unsetRequiredVariables.map( variable => `${translate( 'Group' )}: '${variable.group}', ${translate( 'Variable' )}: '${variable.title}'` ).join( ' | ' )}`;
  }

  renderFooter = () => {
    const chartItem = this.getChartItem( this.props.configuration.model );
    return !chartItem ? null : <Diagram chartName={ chartItem.assignedValue.properties.Chart } parentPanel={ this.resultPanel }/>;
  }

  export = () => {
    const { configuration, currentNode, customExport } = this.props;
    const { customExportTemplate } = currentNode.customProperties;
    const variables = this.getAllVariables( configuration.model );
    let infoData = variables.reduce( ( total, variable ) => {
      total[variable.name] = this.getAssignedValue( variable );
      return total;
    }, {} );

    for( let i = 0; i < this.foundProducts.length; i++ ) {
      const product = this.foundProducts[i];
      product.description = getProductDescription( product );
      Object.assign( infoData, product.properties.reduce( ( total, property ) => {
        total[`${i}_${property?.name.replaceAllOccurrences( { '[': '(', ']': ')' } )}`] = property.value;
        return total;
      }, {} ) );
    }
  
    customExport( 'pdf', Object.values( this.foundProducts ), customExportTemplate, `${customExportTemplate}.pdf`, infoData );
  }

  getAssignedValue( variable ) {
    return variable && variable?.showAs === 'Calculated' 
      ? variable.properties.CalculatedValue 
      : variable.assignedValue 
        ? variable.assignedValue.name 
        : variable.properties.DefaultValue;
  }

  setResultPanel = div => this.resultPanel = div

  setAccordion = accordion => this.accordion = accordion
  assignCountry () {
    const { configuration, product, user } = this.props;
    if( configuration ){
      const variables = configuration.model.children.filter( val => val.fullyQualifiedName == 'Availability' )
      for ( let variable of variables ) {
        if( variable.variables[0].name == 'LSO'){
          this.props.assignValue( variable.variables[0].fullyQualifiedName, user.country );
        }
      }
    }
  }

  resetFeasibilityConfiguration = () => {
    const { resetConfigurator } = this.props;
    setTimeout( () => resetConfigurator(), 0 );
    setTimeout( () => this.props.resetFeasibilityConfigurator(), 0 );
  }
      
  showFeasibilityPopup = () => {
    const { configuration, assignValue, removeValue, currentNode, deflateModelVariables } = this.props;
    return this.props.setPopup( {
      title: translate('Check Feasibility'),
      onClose: () => this.resetFeasibilityConfiguration(),
      // onClose: () => name && setTimeout( () => this.props.removeConfiguration( { name } ), 0 ),
      component: <FeasibilityPopup materialKey={configuration.materialKey} deflateModelVariables={deflateModelVariables} assignValue={assignValue} removeValue={removeValue} currentNode={currentNode}/>,
      showHeader: true,
      keepOpen: true,
    } );
  }

  saveWildArticles = (data) => {
    data = data.map(i => {
      if(!this.props.modelConfigurator[i.code]) {
        this.props.setNewAmountToQuantityList(this.props.modelConfigurator,i.code, 1);
      }
      return {
        assignedValue: {
          name: i.code,
          title: i.productDescription,
          netPrice: i.netPrice
        },
        group: 'Wild Articles',
        netPrice: i.netPrice,
        name: i.code,
        code: i.code,
        description: i.productDescription,
      }
    })
    this.setState({wildArticles: data});
  }

  openWildArticlesPopup = () => {
    return this.props.setPopup( {
      title: translate('Wild Articles') || 'Wild Articles',
      component: <WildArticle wildArticles={this.state.wildArticles} saveWildArticles={this.saveWildArticles} />,
      showHeader: true,
      keepOpen: false
    } );
  }
      
  render() {
  //   if(this.props.currentPage.currentPage!=="modelConfiguratorPage"){
  //     this.props.setPage("modelConfiguratorPage")
  //  }
    const { configuration, currentNode, assignValue, removeValue, siteSettings, screenSize } = this.props;
    const { model } = configuration;
    const description=this.props?.products[this.state?.requiredAssignments?.[0].name]?.description;
    var placeholder_value=''
    // if(siteSettings.properties.vt){
    //   const {additionalSpecification}=siteSettings.properties.vt;
    //   additionalSpecification?.forEach(spec=>{if(description?.includes(spec)){
    //     placeholder_value="Select...";
    // }
    // })
    // }
    // const {additionalSpecification}=siteSettings?.properties?.vt;
    siteSettings?.properties?.vt?.additionalSpecification?.forEach(spec=>{if(description?.includes(spec)){
      placeholder_value="Select "+spec;
   }
   })
    
    if ( !model ) {
      return null;
    }
    let currentView  = 'modelconfiguratorproduct';
    let showCategoryInBomView =  currentNode.nodeId === "9AACWavePro" ? true : false
    const { variantSource, defaultAmount, canAddWildArticle } = currentNode && currentNode.customProperties;
    const lang = getLanguages().first();
    //var showProducts = true;//to Load/Hide Generic viewer component for specual view (variantSource)
    const unsetRequiredVariables = this.getAllVariables( model ).filter( variable => isRequired( variable ) && !getAssignedValue( variable ) && variable.show );
    const debugViewer = siteSettings.properties.isTestEnvironment;
    //const addSettings = { disabled : true, hidden: false }
    let boms = this.canLoadProducts(unsetRequiredVariables) && this.getBomItems( model, configuration, lang, variantSource, unsetRequiredVariables,currentNode );
    boms = Array.isArray(boms) ? boms : [];
	  const addSettings = { 
      disabled: !this.foundProducts || this.foundProducts.length === 0 || boms.length !== this.foundProducts.length, 
      hidden: currentNode.customProperties && currentNode.customProperties.canAddToCart !== undefined && !currentNode.customProperties.canAddToCart
    }
    let headerTranslationKey = 'Component configuration' 
    if ( !variantSource ) {
      this.foundProducts = this.getProducts( boms, unsetRequiredVariables,currentNode );
      addSettings.disabled = !this.foundProducts || this.foundProducts.length === 0 || boms.length !== this.foundProducts.length;
      addSettings.hidden = currentNode.customProperties && currentNode.customProperties.canAddToCart !== undefined && !currentNode.customProperties.canAddToCart;
    } else {
      currentView = currentNode.customProperties && currentNode.customProperties.productListTemplate ? currentNode.customProperties.productListTemplate : 'product';
      this.foundProducts = boms ;
      //showProducts = this.canLoadProducts(unsetRequiredVariables);
      headerTranslationKey = this.foundProducts ? this.productsCount + ' products found' : this.getRequiredTooltip(unsetRequiredVariables);
      addSettings.hidden = true;
    }
    const fromModelConfigurator = checkIsBomItemMain(configuration);
    //Hide export button
    const hideExportButton = currentNode.customProperties?.hideExportButton;
    const uiGroups = model.children.filter( group => hasAnyAssignableValues( group ) && group.fullyQualifiedName != 'Availability' ).map( 
      ( child, key ) => child.show && <><UiGroup  checkForInputField={this.state.checkForInputFields} setCheckForInputFields={this.setCheckForInputFields} key={ child.title + key + AssignmentType.createHashKey( child.variables ) } 
          group={ child }  
          hasChildren={ child.hasChildren }
          children={ child.children }
          assignValue={ assignValue } 
          removeValue={ removeValue } 
          reset={ this.handleReset( child, key ) }
          configuration={ configuration }
          lang = {getLanguages().first()}
          checkFeasibility = {key === 0 && currentNode.customProperties?.checkFeasibility && {onClick: this.showFeasibilityPopup}} 
          deflateModelVariables = {this.props.deflateModelVariables}
          placeholder_value={placeholder_value}
          isAccordionRequired={false}
          screenSize = {screenSize}
        />
          <div className="separator"></div>
        </>
    );
    if(canAddWildArticle) {
      uiGroups.push(<Accordion key="wild_articles" className="wild_articles" defaultExpanded="false" fromModelConfigurator = {fromModelConfigurator}>
        <h3>{translate('Wild Articles') || 'Wild Articles'}
          <SvgImage source={ addIcon } className="reset-icon" addNewWildArticle={this.addNewWildArticle} onClick={this.openWildArticlesPopup} />
        </h3>
        <div></div>
      </Accordion>);
      boms = boms.concat(this.state.wildArticles);
      this.foundProducts = this.foundProducts.concat(this.state.wildArticles);
    }
    addSettings.disabled = unsetRequiredVariables.length>0 ||  !this.foundProducts || this.foundProducts.length === 0  ;
    const uiGroupsModels = uniq(boms.map(b => b.group?.split('.')[0]));

    const mobileTabs = [
      [
        {
          title: 'Configurator',
          component: <div className="col-4 model-configurator-selectors">  
                      { uiGroups }
                      <span style={{display: 'none'}}>
                     
                      <GenericViewer 
              items={ boms } 
              view={ currentView } 
              template={ !variantSource && BomItem }
              footer={ this.renderFooter }
              onScroll = { this.onScroll }
              configuration = {configuration}
              currentNode = {currentNode}
              className = {"mobile-list-view"}
            />
                      </span>
                    </div>,
          properties: this.props,
        },
        {
          title: 'Results',
          component: boms.length!==0?<div ref={ this.setResultPanel } className={`col-8 model-configurator-results ${fromModelConfigurator ? "fromModelConfigurator-results" : ""}`}>
          <div className='product-breadcrumb-header' id="product-breadcrumb-header" style={{height:"5%"}}>
            <BreadcrumbHeader 
                  // setBack={ this.pageCounter > 1 }
                  // onBack={ this.onBack }
                  isIntegrated={ siteSettings.isIntegrated } 
                  pathname={ document.location.hash }
                />
          </div>
          <Accordion defaultExpanded ref={ this.setAccordion } fromModelConfigurator = {fromModelConfigurator}>
            <h3>
              { translate( headerTranslationKey ) }
              { 
                unsetRequiredVariables.length > 0 && 
                <SvgImage source={ warningIcon1 } className="warning-icon" toolTip={ this.getRequiredTooltip( unsetRequiredVariables ) }/> 
              } 
              {/* <div>
                { 
                  currentNode.customProperties && currentNode.customProperties.customExportTemplate && <IconButton 
                    className="export-icon blue-button" 
                    disabled={ addSettings.disabled }
                    text={ translate( 'Export' ) } 
                    icon={ downloadIcon } 
                    onClick={ this.export }
                  />
                }
                { 
                  !addSettings.hidden && <ActionPanel add={ addSettings } product={ this.foundProducts }/>
                }
              </div>           */}
            </h3>
            {showCategoryInBomView && boms && uiGroupsModels && uiGroupsModels.map(uiGroupModel => 
            <Accordion defaultExpanded key={uiGroupModel} fromModelConfigurator = {fromModelConfigurator}>
              <h3>{translate(uiGroupModel)}</h3>
              <GenericViewer 
                items={ boms.filter(b => b.group.indexOf(uiGroupModel) > -1) } 
                view={ fromModelConfigurator ? "modelconfiguratorquantity" : currentView } 
                template={ !variantSource && BomItem }
                footer={ this.renderFooter }
                onScroll = { this.onScroll }
                configuration = {configuration}
                currentNode = {currentNode}
                fromModelConfigurator= {fromModelConfigurator}
                unsetRequiredVariables={unsetRequiredVariables}
              />
            </Accordion>
          )}
        {!showCategoryInBomView && boms.length!==0&&<div className='header-2'>
        <span>
        { translate( 'Selected: {amount}', { amount: boms.length || 0 } ) }
        </span></div>}
          {!showCategoryInBomView && <GenericViewer 
              items={ boms } 
              view={ currentView } 
              template={ !variantSource && BomItem }
              footer={ this.renderFooter }
              onScroll = { this.onScroll }
              configuration = {configuration}
              currentNode = {currentNode}
              className = {"mobile-list-view"}
            />}
            { debugViewer && <h3>Debug viewer</h3> }
            { debugViewer && <div><ModelDebugViewer model={ model } /></div> }
          </Accordion>
          
        </div>:<SelectFilterMessage 
                      message="Use dropdowns or search bar on the left to select the accessories you need."
                      icon={GreyFilterEmptyIconNew}></SelectFilterMessage>,
          properties: this.props,
          accessories: boms,
          mobileTab:true,
        },
      ]
    ]
    return <div className="model-configurator">
        {screenSize.width>900?<div className='model-configurator-content'>
          <div className="col-4 model-configurator-selectors">  
            { uiGroups }
          </div>
          <div ref={ this.setResultPanel } className={`col-8 model-configurator-results ${fromModelConfigurator ? "fromModelConfigurator-results" : ""}`} onClick={()=>this.checkForInputFields(true)}>
            <div className='product-breadcrumb-header' id="product-breadcrumb-header" style={{height:"5%"}}>
              <BreadcrumbHeader 
                    // setBack={ this.pageCounter > 1 }
                    // onBack={ this.onBack }
                    isIntegrated={ siteSettings.isIntegrated } 
                    pathname={ document.location.hash }
                  />
            </div>
            {boms.length===0?<SelectFilterMessage 
                      message="Use dropdowns or search bar on the left to select the accessories you need."
                      icon={GreyFilterEmptyIconNew}></SelectFilterMessage>:
            <Accordion defaultExpanded ref={ this.setAccordion } fromModelConfigurator = {fromModelConfigurator} className={fromModelConfigurator ? "fromModelConfigurator-model-results" : undefined}>
              <h3>
                { translate( headerTranslationKey ) }
                { 
                  unsetRequiredVariables.length > 0 && 
                  <SvgImage source={ warningIcon1 } className="warning-icon" toolTip={ this.getRequiredTooltip( unsetRequiredVariables ) }/> 
                } 
                {/* <div>
                  { 
                    currentNode.customProperties && currentNode.customProperties.customExportTemplate && <IconButton 
                      className="export-icon blue-button" 
                      disabled={ addSettings.disabled }
                      text={ translate( 'Export' ) } 
                      icon={ downloadIcon } 
                      onClick={ this.export }
                    />
                  }
                  { 
                   !addSettings.hidden && <ActionPanel defaultAmount={defaultAmount} fromModelConfigurator={fromModelConfigurator} add={ addSettings } product={ this.foundProducts }  oldProduct={this.props.oldProduct} unsetRequiredVariables={unsetRequiredVariables} showTechnicalSpec={true}/>
                  }
                </div>           */}
              </h3>
              {showCategoryInBomView && boms && uiGroupsModels && uiGroupsModels.map(uiGroupModel => 
            <Accordion defaultExpanded key={uiGroupModel} fromModelConfigurator = {fromModelConfigurator}>
              <h3>{translate(uiGroupModel)}</h3>
              <GenericViewer 
                items={ boms.filter(b => b.group.indexOf(uiGroupModel) > -1) } 
                view={ fromModelConfigurator ? "modelconfiguratorquantity" : currentView } 
                template={ !variantSource && BomItem }
                footer={ this.renderFooter }
                onScroll = { this.onScroll }
                configuration = {configuration}
                currentNode = {currentNode}
                fromModelConfigurator= {fromModelConfigurator}
                unsetRequiredVariables={unsetRequiredVariables}
              />
            </Accordion>
          )}
          {!showCategoryInBomView && boms.length!==0&&<div className='header-2'>
          <span>
          { translate( 'Selected: {amount}', { amount: boms.length || 0 } ) }
          </span></div>}
            {!showCategoryInBomView && <GenericViewer 
                items={ boms } 
                view={ currentView } 
                template={ !variantSource && BomItem }
                footer={ this.renderFooter }
                onScroll = { this.onScroll }
                configuration = {configuration}
                currentNode = {currentNode}
              />}
              { debugViewer && <h3>Debug viewer</h3> }
              { debugViewer && <div><ModelDebugViewer model={ model } /></div> }
            </Accordion>}
            
          </div>
        </div>:<Tab tabs={mobileTabs}></Tab>}
        <div className="model-configurator-footer">
          {/* <h3>
            { translate( headerTranslationKey ) }
          </h3> */}
            {/* { 
              unsetRequiredVariables.length > 0 && 
              <SvgImage source={ warningIcon1 } className="warning-icon" toolTip={ this.getRequiredTooltip( unsetRequiredVariables ) }/> 
            }  */}
            <div className='action-items'>
              { 
                currentNode.customProperties && currentNode.customProperties.customExportTemplate && !hideExportButton && <IconButton 
                  className="export-icon blue-button" 
                  disabled={ addSettings.disabled }
                  text={ translate( 'Export' ) } 
                  icon={ downloadIcon } 
                  onClick={ this.export }
                />
              }
              {/* { 
              <SvgImage source={ warningIcon1 } className="warning-icon" toolTip={ this.getRequiredTooltip( unsetRequiredVariables ) }/> 
            } 
            <div className='action-items'>
              { 
               <IconButton 
                  className="export-icon blue-button" 
                  disabled={ addSettings.disabled }
                  text={ translate( 'Export' ) } 
                  icon={ downloadIcon } 
                  onClick={ this.export }
                />
              } */}
              { 
                !addSettings.hidden && <ActionPanel fromCart= {!!(window.location.href.includes('/reconfigure') && fromModelConfigurator) } defaultAmount={defaultAmount} oldProduct={this.props.oldProduct} add={ addSettings } product={ this.foundProducts } fromModelConfiguratorFooter={true} fromModelConfigurator= {fromModelConfigurator}/>
              }
            </div>          
        </div>
    </div>;
  }
}

ModelConfiguratorComponent.propTypes = {
  assignValue: PropTypes.func.isRequired, 
  configuration: PropTypes.shape( {
    productModelType: PropTypes.number
  } ), 
  customExport: PropTypes.func.isRequired,
  currentNode: PropTypes.shape( {
    customProperties: PropTypes.shape( {
      canAddToCart: PropTypes.boolean,
      customExportTemplate: PropTypes.string,
      variantSource: PropTypes.string
    } )
  } ),
  products: PropTypes.shape( {} ), 
  removeValue: PropTypes.func.isRequired,
  resetConfigurator: PropTypes.func.isRequired, 
  resetGroup: PropTypes.func.isRequired,
  siteSettings: PropTypes.shape( {
    properties: PropTypes.shape( {
      isTestEnvironment: PropTypes.bool
    } )
  } )
};

export const ModelConfigurator = connect( combineStates( currentNodeState,modelConfiguratorState, productState, siteSettingsState, identityState, screenSizeState, currentPageState  ), combineDispatchers( productsDispatcher, popupDispatcher, exportDispatcher, priceDispatcher, feasibilityDispatcher, currentPageDispatcher, screenSizeDispatcher,modelConfiguratorDispatcher ) )( ModelConfiguratorComponent );